import React, { useContext, useEffect, useState } from "react";
import { db } from "../../index";
import { onValue, ref, set } from "firebase/database";
import { uid } from "uid";
import "./AddRequest.css";
import { useNavigate } from "react-router-dom";
import { Context } from "../Context/AuthContext";
import InputMask from 'react-input-mask';

export function AddRequest() {
const { user } = useContext(Context);

const [formData, setFormData] = useState({
    nameObject: "",
    address: "",
    contactPersonName: "",
    contactPersonPhone: "",
    engineer: null,
    date: "",
    description: "",
    selectedImage: "",
    idRequest: false,
});

const today = new Date().toISOString().split("T")[0];
const navigate = useNavigate();

const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({ ...prevFormData, [name]: value }));
};

const handleEngineerChange = (e) => {
    setFormData((prevFormData) => ({ ...prevFormData, engineer: e.target.value }));
  };

const handleRadioChange = (e) => {
    setFormData((prevFormData) => ({ ...prevFormData, selectedImage: e.target.value }));
};

const writeToDataBase = (e) => {
    e.preventDefault();
    if (formData.engineer === null || formData.engineer === "Выберите инженера") {
        alert("Пожалуйста, выберите инженера");
        return;
    }
    const phoneRegex = /^\+7\(\d{3}\) \d{3}-\d{2}-\d{2}$/;
    if (!phoneRegex.test(formData.contactPersonPhone)) {
        alert("Пожалуйста, введите полный номер телефона");
        return;
    }
    const id = uid();
    if (new Date(formData.date).getTime() >= new Date(today).getTime()) {
        try {
            set(ref(db, `request/${id}`), {
                id,
               ...formData,
                createdDate: today,
                dispatcher: user.email,
                dispatcherID: user.uid
            });
            console.log("Данные успешно добавлены");
            alert("Данные успешно добавлены");
            navigate("/openedRequest");
        } catch (error) {
            console.error("Ошибка добавления данных:", error);
            alert("Ошибка добавления данных. Пожалуйста попробуйте снова");
        }
    } else {
        alert("Выбранная дата не может быть раньше сегодняшнего дня");
    }
};

const handleCancelClick = () => {
    setFormData({
        nameObject: "",
        address: "",
        contactPersonName: "",
        contactPersonPhone: "",
        engineer: "",
        date: "",
        description: "",
        selectedImage: "",
    });
};

const [engineers, setEngineers] = useState([]);

  const fetchEngineers = () => {
    const usersRef = ref(db, "users");
    onValue(usersRef, (snapshot) => {
      const usersData = snapshot.val();
      const engineersList = Object.values(usersData).filter((user) => user.role === "Инженер");
      setEngineers(engineersList);
    });
  };

  useEffect(() => {
    fetchEngineers();
  }, []);
  
  const [openRequestsCount, setOpenRequestsCount] = useState({});

  const fetchOpenRequests = (engineer, date) => {
    const requestsRef = ref(db, `request`);
    onValue(requestsRef, (snapshot) => {
      const requests = Object.entries(snapshot.val());
      const openRequests = requests.filter(([key, request]) => request.engineer === engineer && request.date === date &&!request.idRequest);
      setOpenRequestsCount((prevCount) => ({...prevCount, [engineer]: openRequests.length }));
    });
  };
  
  useEffect(() => {
    fetchOpenRequests(formData.engineer, formData.date);
  }, [formData.engineer, formData.date]);
  

return (
    <div className="aside-right__desc center">
        <form className="modal" onSubmit={writeToDataBase}>
            <h2>Добавить заявку</h2>
            <div className="modal__item">
                <label htmlFor="nameObject">Объект
                    <input
                        id="nameObject"
                        type="text"
                        name="nameObject"
                        value={formData.nameObject}
                        onChange={handleInputChange}
                        placeholder="Название объекта"
                        required
                    />
                </label>
            </div>
            <div className="modal__item">
                <label htmlFor="address">Адрес
                    <input
                        id="address"
                        type="text"
                        name="address"
                        value={formData.address}
                        onChange={handleInputChange}
                        placeholder="Адрес"
                        required
                    />
                </label>
            </div>
            <div className="modal__item flex media__alert">
                <label htmlFor="priority">Приоритет заявки
                    <div className="modal__radio-wrapper">
                        <div className="modal__radio">
                            <input
                                type="radio"
                                id="radioRegular"
                                name="priority"
                                value="./img/low-priority.svg"
                                checked={formData.selectedImage === "./img/low-priority.svg"}
                                onChange={handleRadioChange}
                                required
                            />
                            <span>Обычный</span>
                        </div>
                        <div className="modal__radio">
                            <input
                                type="radio"
                                id="radioHigh"
                                name="priority"
                                value="./img/high-priority.svg"
                                checked={formData.selectedImage === "./img/high-priority.svg"}
                                onChange={handleRadioChange}
                                required
                            />
                            <span>Высокий</span>
                        </div>
                    </div>
                </label>
                <div className="alert-text">Будьте внимательны!
                    <p>Потом изменить приоритет будет <span>нельзя</span></p>
                </div>
            </div>
            <div className="modal__item">
                <label htmlFor="contactPerson">Контактное лицо на объекте
                    <div className="contactPerson">
                        <InputMask
                            id="contactPersonName"
                            type="text"
                            name="contactPersonName"
                            value={formData.contactPersonName}
                            onChange={handleInputChange}
                            pattern="[a-zA-Zа-яА-Я\s]+"
                            placeholder="Имя"
                            required
                        />
                        <InputMask
                            id="contactPersonPhone"
                            type="tel"
                            name="contactPersonPhone"
                            value={formData.contactPersonPhone}
                            onChange={handleInputChange}
                            mask="+7(999) 999-99-99"
                            placeholder="Телефон"
                            alwaysShowMask
                            required
                        />
                    </div>
                </label>
            </div>
            <div className="modal__item">
                <label htmlFor="engineer">Инженер
                <select className="field-input block" name="engineer" value={formData.engineer} onChange={handleEngineerChange}>
                    <option value={null}>Выберите инженера</option>
                    {engineers.map((engineer) => (
                        <option key={engineer.userID} value={engineer.displayName}>
                        {engineer.displayName}
                        </option>
                    ))}
                </select>
                </label>
            </div>
            <div className="modal__item flex quality-engineer">
                <label htmlFor="date">Дата ремонта
                    <input 
                        className="inputDate"
                        type="date"
                        name="date"
                        value={formData.date}
                        onChange={handleInputChange}
                        placeholder="Дата ремонта"
                        required
                    />
                </label>
                {openRequestsCount[formData.engineer]? <p>{openRequestsCount[formData.engineer]} открытых заявок</p> : ''}
            </div>
            <div className="modal__item modal__textarea">
                <label htmlFor="description">Описание проблемы
                    <textarea
                        id="textarea"
                        type="text"
                        name="description"
                        value={formData.description}
                        onChange={handleInputChange}
                        placeholder="Опишите проблему"
                        formcontrolname="description"
                        maxLength="400"
                        required
                    />
                </label>
            </div>
            <div className="modal__actions">
                <button type="reset" className="modal__button btn-item_close" onClick={handleCancelClick}>Отменить</button>
                <button type="submit" className="modal__button btn-item">Добавить</button>
            </div>
        </form>
    </div>
    );
}